export const putSave = (payload: any) => ({ type: 'save', payload })

